var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { locale as polish } from '../../../../translations/pl';
import { locale as english } from '../../../../translations/en';
import { MatDialog } from '@angular/material';
import { TagsService } from '../../../../services/tags.service';
import { TagEditorComponent } from '../tag-editor/tag-editor.component';
import { List } from '../../../../shared/models/list.class';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
var TagsListComponent = /** @class */ (function (_super) {
    __extends(TagsListComponent, _super);
    function TagsListComponent(tagsService, matDialog, authService, _fuseTranslationLoaderService) {
        var _this = _super.call(this) || this;
        _this.tagsService = tagsService;
        _this.matDialog = matDialog;
        _this.authService = authService;
        _this._fuseTranslationLoaderService = _fuseTranslationLoaderService;
        _this.displayedColumns = ['name', 'active'];
        _this.listFilters = {};
        _this._fuseTranslationLoaderService.loadTranslations(polish, english);
        _this.reloadList$ = tagsService.onEditEvent.subscribe(function () {
            _this.getElementsList();
        });
        _this.getElementsList = function () {
            _this.tagsService.getTagsList(_this.getQueryParams())
                .subscribe(function (res) {
                _this.totalCount = res.totalCount;
                _this.dataSource = res.tags;
            });
        };
        return _this;
    }
    TagsListComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.user = this.authService.getUser();
        this.getElementsList();
        this.createSearchFormControl();
    };
    TagsListComponent.prototype.ngOnDestroy = function () {
        this.reloadList$.unsubscribe();
    };
    TagsListComponent.prototype.addTag = function () {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(TagEditorComponent, {
            panelClass: 'tag-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'add'
            }
        });
    };
    TagsListComponent.prototype.viewTag = function (tagUuid) {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(TagEditorComponent, {
            panelClass: 'tag-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'view',
                tagUuid: tagUuid
            }
        });
    };
    TagsListComponent.prototype.clearSearch = function () {
        if (this.searchTag.value) {
            this.searchTag.setValue('');
        }
    };
    TagsListComponent.prototype.getListFilters = function (filters) {
        this.listFilters = filters;
        this.requestParams.page = 1;
        this.disableAnimations = true;
        this.getElementsList();
    };
    TagsListComponent.prototype.createSearchFormControl = function () {
        var _this = this;
        this.searchTag = new FormControl('');
        this.searchTag.valueChanges.debounceTime(300).subscribe(function (value) {
            _this.requestParams.search = value;
            _this.requestParams.page = 1;
            _this.disableAnimations = true;
            _this.getElementsList();
        });
    };
    TagsListComponent.prototype.getQueryParams = function () {
        return Object.assign({}, this.requestParams, this.listFilters);
    };
    return TagsListComponent;
}(List));
export { TagsListComponent };
